import InformationModal from '../../../shared/components/modal-information';

const TOUCH_THRESHOLD = 5;
export default class NewlyCompletedBadgesModal extends InformationModal {
  bindEvents() {
    super.bindEvents();

    // From https://stackoverflow.com/a/40401975/1518131, native touch isn't supported in bootstrap 3
    $('.carousel').on('touchstart', function (event) {
      const xClick = event.originalEvent.touches[0].pageX;
      $(this).one('touchmove', function (event) {
        const xMove = event.originalEvent.touches[0].pageX;
        if (Math.floor(xClick - xMove) > TOUCH_THRESHOLD) {
          $(this).carousel('next');
        } else if (Math.floor(xClick - xMove) < -TOUCH_THRESHOLD) {
          $(this).carousel('prev');
        }
      });
      $('.carousel').on('touchend', function () {
        $(this).off('touchmove');
      });
    });
  }

  markModalAsRead() {
    $.ajax({
      url: this.$element.data('read-url'),
      type: 'PUT',
      dataType: 'json',
    });
  }
}
